import axios from 'axios'

const DraftService = {
  async get (params = {}) {
    return axios.get('lo/withdrawal/drafts', { params })
  },

  async show (id) {
    return axios.get(`lo/withdrawal/drafts/${id}`)
  },

  async post (params = {}) {
    return axios.post('lo/withdrawal/drafts', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`lo/withdrawal/drafts/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`lo/withdrawal/drafts/${data.id}`, { data })
  }
}

export default DraftService
